'use client'
import CustomButton from '@/components/common/CustomButton'
import React from 'react'

const UserData = ({ userData, setAuthVisible }) => {

  return (
    <section className='h-auto w-auto max-h-[700px] flex flex-col items-center gap-y-5 bg-white'>
      <h3 className='font-semibold text-xl text-center'>Información de usuario</h3>
      <div className='w-full h-auto flex flex-col justify-center items-center gap-y-4'>
        {
          [
            { title: 'Nombre completo', dbName: 'name' },
            { title: 'Correo electrónico', dbName: 'email' },
            { title: 'Rol', dbName: 'role' },
            { title: 'DNI', dbName: 'dni' },
            { title: 'CUIT', dbName: 'cuit' }
          ].map(({ title, dbName }) => (
            userData[dbName] &&
            <div key={title} className='w-full h-auto flex flex-col items-center'>
              <h5 className='font-semibold text-gray-700 text-sm'>{title}</h5>
              <h4 className='font-semibold text-lg'>{userData[dbName]}</h4>
            </div>
          ))
        }
        <div className='flex items-center gap-x-4'>
          <CustomButton title='Volver' action={() => setAuthVisible({ open: false, step: null })} colorType='primary' />
          <CustomButton title='Cerrar sesión' action={() => setAuthVisible({ open: true, step: 3 })} />
        </div>
      </div>
    </section>
  )
}

export default UserData